import { render, staticRenderFns } from "./TreeviaAcademy.vue?vue&type=template&id=428fe799&scoped=true"
import script from "./TreeviaAcademy.vue?vue&type=script&lang=js"
export * from "./TreeviaAcademy.vue?vue&type=script&lang=js"
import style0 from "./TreeviaAcademy.vue?vue&type=style&index=0&id=428fe799&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428fe799",
  null
  
)

export default component.exports